import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlexibleArrow } from '../../../atoms/FlexibleArrow/FlexibleArrow';
import { ProCol } from '../../../atoms/Grid/Col';
import { ProRow } from '../../../atoms/Grid/Row';
import { ProIconTypeData } from '../../../atoms/Icons/IconData';
import { ProMenuCard } from '../../../atoms/MenuCard/MenuCard';
import { ApplicationElementType, getBaseBCItemForType } from '../../../components/DetailWindow/breadCrump.helpers';
import { ProPage } from '../../../components/Page/Page';
import { MenuItemType } from '../../../constants/types';
import { RoutingHistorySections } from '../../../hooks/useRouting';
import { NotImplemented } from '../../../modules/ProErrorPage/NotImplemented';

const managedMenu: MenuItemType[] = [
    {
        link: '/app/teams/something',
        icon: ProIconTypeData.Finnished,
        name: 'Forecast Session',
        section: RoutingHistorySections.teamManagement,
        iconSection: (
            <>
                SIMULATION
                <FlexibleArrow length={146} relative />
                PLAN
            </>
        ),
        bar: 'horisontal',
    },
];

export const PersonalForecastSessionPage = () => {
    const { t } = useTranslation();
    return (
        <ProPage
            breadCrump={getBaseBCItemForType(
                [ApplicationElementType.PersonalManagement, ApplicationElementType.ForecastSession],
                t
            )}
            name="Forecast Session"
        >
            <NotImplemented message="Forcast sessions" />
            <ProRow className="Ceremonies__managedRow InlineCeremoniesRow">
                {managedMenu.map((cur) => (
                    <ProCol span={4} className="ProCol--notHidden" key={cur.name}>
                        <ProMenuCard item={cur} />
                    </ProCol>
                ))}
            </ProRow>
        </ProPage>
    );
};
